import { useRef, useState } from "react";
import { Modal, Button } from "@etframework/ui.components";
import { useUpdateBoard } from "../../data/mutations/boardMutations";
import { useTranslation } from "react-i18next";
import useModalEvent from "../../hooks/useModalEvent";
import ReactDOM from "react-dom";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";

export const ArchiveBoardConfirmationModal = () => {
  const navigate = useNavigate();
  const { boardId } = useParams();
  const { mutate: updateBoard, isPending } = useUpdateBoard();
  const { t } = useTranslation(["Boards"], {
    useSuspense: false,
  });

  const onArchiveBoard = () => {
    let board = {
      Id: boardId,
      Archived: true,
    };

    updateBoard(
      { board: board },
      {
        onSuccess: () => {
          onModalClose();
          toast.success(t("ArchiveBoardModal.ArchiveSuccess"), {
            position: "bottom-left",
          });
          navigate(`/duedates/settings/boards`);
        },
        onError: () => {
          toast.error(t("ArchiveBoardModal.ErrorMsg"), {
            position: "bottom-left",
          });
          onModalClose();
        },
      }
    );
  };

  //Modal
  const modalRef = useRef();
  const { ModalEvents, useRegisterEvent } = useModalEvent();
  const [showModal, setShowModal] = useState(false);

  const onModelBeforeClose = () => {};

  const onModalClose = () => {
    setShowModal(false);
  };

  const closeModal = () => {
    setShowModal(false);
    modalRef?.current?.close();
  };

  const openModal = () => {
    setShowModal(true);
    modalRef?.current?.open();
  };

  const toggleModal = () => {
    if (showModal) {
      closeModal();
      return;
    } else {
      openModal();
    }
  };

  const ModalContent = () => {
    return (
      <div className="et-board-modal">
        <span className="board-header d-block">
          {t("ArchiveBoardModal.ArchiveBoardHeader")}
        </span>

        <div className="mb-3">
          {t("ArchiveBoardModal.ArchiveBoardMessage1")}
        </div>

        <div className="d-flex justify-content-end board-modal-btns mx-auto gap-3">
          <Button
            text={t("ArchiveBoardModal.Cancel")}
            className="btn-tertiary"
            onClick={toggleModal}
          />
          <Button
            text={t("ArchiveBoardModal.ArchiveBoard")}
            className="btn btn-primary"
            onClick={onArchiveBoard}
            loading={isPending}
          />
        </div>
      </div>
    );
  };

  useRegisterEvent(ModalEvents.ArchiveBoardConfirmationModal, toggleModal);

  return ReactDOM.createPortal(
    <>
      <Modal
        id={ModalEvents.ArchiveBoardConfirmationModal.Id}
        ref={modalRef}
        isModal
        showCloseIcon={true}
        visible={showModal}
        content={<ModalContent />}
        close={onModalClose}
        beforeClose={onModelBeforeClose}
        minHeight="20vh"
        width="487px"
      ></Modal>
    </>,
    document.body
  );
};
